import { ResourceTheme } from '@leverege/ui-elements'
import Theme from './Theme'

export default new ResourceTheme( Theme )